<escala-globales-form
    [evaluacionTipo]="evaluacionTipo"
    [save_button_text]="'Guardar'"
    (saving)="save($event)"
></escala-globales-form>
